import React, {useMemo} from 'react';
import {Box} from '@tempo/core';
import Thumbnail from '@components/Thumbnail';
import {useActiveArtist, useProfiles} from '@deezer/next/contexts/main/hooks';
import {ContentType} from '@deezer/next/services/types/contentType';
import {notNull} from '@deezer/next/shared/utils/array';

const OTHER_PROFILE_LIST_SIZE = 2;

const ArtistPictureList = () => {
	const profiles = useProfiles();
	const activeArtist = useActiveArtist();

	const visibleProfiles = useMemo(() => {
		return [
			...profiles
				.filter(item => item.id !== activeArtist)
				.slice(0, OTHER_PROFILE_LIST_SIZE),
			profiles.find(item => item.id === activeArtist),
		].filter(notNull);
	}, [activeArtist, profiles]);

	return (
		<Box>
			{visibleProfiles.map(item => (
				<Box
					key={item.id}
					marginRight="-10px"
					display="inline-block"
					borderRadius="50%"
					position="relative"
				>
					<Box
						position="absolute"
						background="src/components/Navigation/UserMenu#FFFFFF" // hard coded to use white for opacity base
						borderRadius="50%"
						top={0}
						left={0}
						bottom={0}
						right={0}
					/>
					<Thumbnail
						id={String(item.id)}
						coverLink={false}
						height={'24px'}
						width={'24px'}
						rounded={true}
						picture={item.picture}
						type={ContentType.Artist}
						redirectUrl={item.redirectUrl}
						opacity={item.id === activeArtist ? 1 : 0.5}
					/>
				</Box>
			))}
		</Box>
	);
};

export default ArtistPictureList;
